// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { AddUserComponent } from 'src/app/modules/users/pages/add-user/add-user.page';
import { TaggerListComponent } from 'src/app/modules/users/pages/tagger-list/tagger-list.page';
import { UserDetailComponent } from 'src/app/modules/users/pages/user-detail/user-detail.page';
import { UsersListComponent } from 'src/app/modules/users/pages/users-list/users-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: UsersListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadUsersList']
    },
  },
  {
    path: 'detail/:userId',
    component: UserDetailComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateUsers']
    },
  },
  {
    path: 'detail/:userId/:adminCompanyId',
    component: UserDetailComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateUsers']
    },
  },
  {
    path: 'add',
    component: AddUserComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateUsers']
    },
  },
  {
    path: 'tagger',
    component: TaggerListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadUsersList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class UsersRoutingModule { }
